export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["FIRST_TIME_ONBOARDING"] = "firstTimeOnboarding";
    LocalStorageKey["TAG_SUGGESTION"] = "suggested_tags";
    LocalStorageKey["CHARACTER_RATINGS"] = "character_ratings";
    LocalStorageKey["NSFW_TOGGLE"] = "nsfwToggle";
    LocalStorageKey["LAST_TIME_FILTERED_CHARACTERS"] = "lastTimeFilteredCharacters";
    LocalStorageKey["IS_PARTNER"] = "isPartner";
    LocalStorageKey["INFERENCE_MODEL"] = "inference_model";
    LocalStorageKey["INFERENCE_MAX_NEW_TOKENS"] = "inference_max_new_tokens";
    LocalStorageKey["INFERENCE_TEMPERATURE"] = "inference_temperature";
    LocalStorageKey["INFERENCE_TOP_P"] = "inference_top-p";
    LocalStorageKey["INFERENCE_TOP_K"] = "inference_top-k";
    LocalStorageKey["REMEMBERED_PERSONA_MODAL"] = "rememberedPersonaModal";
    LocalStorageKey["BEAMER_DATE"] = "_BEAMER_DATE_";
    LocalStorageKey["AVATAR_GENERATE_RETRY_AFTER"] = "avatarGenerateRetryAfter";
    LocalStorageKey["DRAFT_LOCAL_STORAGE"] = "draft_character";
    LocalStorageKey["FIRST_TIME_WAITING_QUEUE_MODAL"] = "isFirstTimeWaitingQueueModal";
    LocalStorageKey["CONVIMAGE_LORASCALE"] = "convimage_lorascale";
    LocalStorageKey["CONVIMAGE_MODELSTYLE"] = "convimage_modelstyle";
    LocalStorageKey["CONVIMAGE_NSFWMODE"] = "convimage_nsfwmode";
    LocalStorageKey["ID"] = "Id";
    LocalStorageKey["UNIQUE_NOTIFICATION_IDS"] = "unique_notification_ids";
    LocalStorageKey["LOCALIZATION"] = "localization";
    LocalStorageKey["AVATAR_GENERATOR_MODEL_KEY"] = "avatar_generator_model";
    LocalStorageKey["AVATAR_GENERATOR_STYLE_KEY"] = "avatar_generator_style";
})(LocalStorageKey || (LocalStorageKey = {}));
